export default __webpack_public_path__ + "static/media/line1.6554bf9f.svg";